import { Box, Paper, Stack, Typography } from "@mui/material";

const Section = ({
  title,
  subtitle,
  chips = [],
  buttons = [],
  spacing = 1.5,
  children,
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      borderRadius: 3,
      border: (t) => `1px solid ${t.palette.divider}`,
      bgcolor: "background.paper",
    }}
  >
    <Stack spacing={spacing}>
      <Box>
        <Stack
          spacing={1}
          direction="row"
          alignItems="start"
          justifyContent="space-between"
        >
          <Stack
            spacing={{ xs: 0, sm: 1 }}
            direction={{ xs: "column", sm: "row" }}
            alignItems="start"
          >
            <Typography
              variant="overline"
              color="text.primary"
              sx={{ letterSpacing: 0.6, fontSize: 15 }}
            >
              {title}
            </Typography>
            {chips.map((r, i) => r(i))}
          </Stack>
          {buttons.map((r, i) => r(i))}
        </Stack>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {children}
    </Stack>
  </Paper>
);

export default Section;
